var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(42.2118 0 0 42.2118 490.2154 490.2154)",
    id: 574673
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.305 -0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(157,153,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-10.695, -10.695)",
    d: "M 10.695 0.115845 C 8.60263 0.115845 6.55725 0.736302 4.81752 1.89876 C 3.07778 3.06121 1.72182 4.71345 0.92111 6.64654 C 0.120398 8.57963 -0.0891048 10.7067 0.319095 12.7589 C 0.727294 14.8111 1.73486 16.6961 3.21439 18.1756 C 4.69391 19.6551 6.57894 20.6627 8.63109 21.0709 C 10.6833 21.4791 12.8104 21.2696 14.7435 20.4689 C 16.6766 19.6682 18.3288 18.3122 19.4912 16.5725 C 20.6537 14.8327 21.2742 12.7874 21.2742 10.695 C 21.2742 9.30574 21.0005 7.93006 20.4689 6.64654 C 19.9372 5.36302 19.158 4.19678 18.1756 3.21441 C 17.1932 2.23204 16.027 1.45279 14.7435 0.921136 C 13.4599 0.389483 12.0843 0.115845 10.695 0.115845 Z M 10.695 19.1583 C 9.0211 19.1583 7.3848 18.662 5.99301 17.732 C 4.60122 16.8021 3.51646 15.4803 2.87589 13.9338 C 2.23532 12.3873 2.06771 10.6856 2.39427 9.0439 C 2.72083 7.40217 3.52689 5.89415 4.71051 4.71053 C 5.89412 3.52691 7.40215 2.72086 9.04387 2.3943 C 10.6856 2.06774 12.3873 2.23534 13.9338 2.87591 C 15.4802 3.51648 16.802 4.60125 17.732 5.99304 C 18.662 7.38482 19.1583 9.02112 19.1583 10.695 C 19.1583 12.9396 18.2667 15.0923 16.6795 16.6795 C 15.0923 18.2667 12.9396 19.1583 10.695 19.1583 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.305 -0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(157,153,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-10.6949, -10.695)",
    d: "M 13.5619 7.82807 C 13.4636 7.72891 13.3466 7.65021 13.2176 7.5965 C 13.0887 7.54279 12.9505 7.51514 12.8108 7.51514 C 12.6711 7.51514 12.5329 7.54279 12.4039 7.5965 C 12.275 7.65021 12.158 7.72891 12.0597 7.82807 L 10.695 9.20336 L 9.33025 7.82807 C 9.13104 7.62886 8.86085 7.51694 8.57913 7.51694 C 8.2974 7.51694 8.02722 7.62886 7.82801 7.82807 C 7.6288 8.02728 7.51688 8.29746 7.51688 8.57919 C 7.51688 8.86091 7.6288 9.1311 7.82801 9.33031 L 9.2033 10.695 L 7.82801 12.0597 C 7.72885 12.1581 7.65015 12.2751 7.59644 12.404 C 7.54273 12.5329 7.51508 12.6712 7.51508 12.8109 C 7.51508 12.9505 7.54273 13.0888 7.59644 13.2177 C 7.65015 13.3466 7.72885 13.4636 7.82801 13.562 C 7.92635 13.6611 8.04336 13.7398 8.17228 13.7935 C 8.30119 13.8473 8.43947 13.8749 8.57913 13.8749 C 8.71878 13.8749 8.85706 13.8473 8.98598 13.7935 C 9.11489 13.7398 9.2319 13.6611 9.33025 13.562 L 10.695 12.1867 L 12.0597 13.562 C 12.158 13.6611 12.275 13.7398 12.4039 13.7935 C 12.5329 13.8473 12.6711 13.8749 12.8108 13.8749 C 12.9505 13.8749 13.0887 13.8473 13.2176 13.7935 C 13.3466 13.7398 13.4636 13.6611 13.5619 13.562 C 13.6611 13.4636 13.7398 13.3466 13.7935 13.2177 C 13.8472 13.0888 13.8748 12.9505 13.8748 12.8109 C 13.8748 12.6712 13.8472 12.5329 13.7935 12.404 C 13.7398 12.2751 13.6611 12.1581 13.5619 12.0597 L 12.1866 10.695 L 13.5619 9.33031 C 13.6611 9.23196 13.7398 9.11495 13.7935 8.98604 C 13.8472 8.85712 13.8748 8.71885 13.8748 8.57919 C 13.8748 8.43953 13.8472 8.30125 13.7935 8.17234 C 13.7398 8.04342 13.6611 7.92641 13.5619 7.82807 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.5b383090aa295bb3cf5e414a679daaab.svg";
export { ForwardRef as ReactComponent };